import viewportState from "@src/app/stores/viewport";
import { useEffect } from "react";

declare global {
  interface Window {
    instgrm?: {
      Embeds: {
        process: () => void;
      };
    };
  }
}

interface InstagramEmbedProps {
  url: string;
  width?: string | number;
}

export default function ArticleEmbedInstagram({
  url,
  width,
}: InstagramEmbedProps) {
  const { isMobileView } = viewportState;

  useEffect(() => {
    if (!window.instgrm) {
      const script = document.createElement("script");
      script.async = true;
      script.defer = true;
      script.src = "https://www.instagram.com/embed.js";
      document.body.appendChild(script);

      script.onload = () => {
        window.instgrm?.Embeds.process();
      };
    } else {
      window.instgrm.Embeds.process();
    }
  }, [url]);

  return (
    <blockquote
      className="instagram-media"
      data-instgrm-captioned
      data-instgrm-permalink={url}
      data-instgrm-version="14"
      style={{
        maxWidth: 550,
        minWidth: 326,
        width: width ? width : isMobileView ? "100%" : "550px",
        margin: "1px auto",
        background: "#fff",
        borderRadius: 3,
        padding: 0,
      }}
    >
      <a href={url} target="_blank" rel="noopener noreferrer">
        View this post on Instagram
      </a>
    </blockquote>
  );
}
